import { Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

export default function BeltNoDataAvailable() {
  const { t } = useTranslation();

  return (
    <Stack flex={1} alignItems='center' justifyContent='center' sx={{ paddingLeft: 2 }}>
      <Typography variant='body1' sx={{ width: 'max-content' }}>
        {t('belt.noDataAvailable')}
      </Typography>
    </Stack>
  );
}
